module.exports = __webpack_public_path__ + "static/media/010-The Growling Gator.a523147c.png";